<template>
  <div class="flight-editor responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="pageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'flights', label: 'Bundles' },
          {
            name: 'flightEditor',
            label: selectedFlight.name,
            query: $route.query,
          },
        ]"
        :isEdit="isEdit"
        :isCollapsed="isCollapsed"
        :selectedEntity="selectedFlight"
        @updateIsEdit="isEdit = $event"
        :entity="entity"
        @toggle-edit="toggleEdit"
        @toggle-sections="forceToggle"
        @handle-adjacent="handleAdjacent"
        @show-search-modal="toggleSearchModal"
      />
      <div class="section-base">
        <div
          style="position: relative"
          class="padded elevated-0 bordered"
          :class="{
            'bordered__highlighted--danger':
              selectedFlight.isDeleted || selectedFlight.isArchived,
          }"
        >
          <transition name="fade">
            <ContainerLabel
              v-if="selectedFlight.isDeleted"
              type="danger"
              text="DELETED"
            />
          </transition>
          <div class="flight-editor__grid">
            <Input
              :model="selectedFlight.name"
              :inputData="getInput('name')"
              :isEdit="isEdit"
              @updateModel="selectedFlight.name = $event"
            />
            <Input
              :model="selectedFlight.isActive"
              :inputData="getInput('isActive')"
              :isEdit="isEdit"
              @updateModel="selectedFlight.isActive = $event"
            />
          </div>
          <div class="flight-editor__grid">
            <!-- <Input
              :model="selectedFlight.menuUpload"
              :inputData="getInput('menuUpload')"
              :isEdit="isEdit"
              @updateModel="selectedFlight.menuUpload = $event"
            /> -->
            <Input
              :model="selectedFlight.isPublishedToOnlineStore"
              :inputData="getInput('isPublishedToOnlineStore')"
              :isEdit="isEdit"
              @updateModel="selectedFlight.isPublishedToOnlineStore = $event"
            />


            <Input
              :model="selectedFlight.saleType"
              :inputData="getInput('saleType')"
              :isEdit="isEdit"
              @updateModel="selectedFlight.saleType = $event"
            />
          </div>
          <div>
            <div class="flight-editor__grid">
              <div>
                <Input
                  :model="selectedFlight.salePrice"
                  :inputData="getInput('salePrice')"
                  :isEdit="isEdit"
                  @updateModel="selectedFlight.salePrice = $event"
                />
              </div>
              <div>
                <Input
                  :model="selectedFlight.grams"
                  :inputData="getInput('grams')"
                  :isEdit="isEdit"
                />
              </div>
            </div>
            <Input
              class="flight-editor__grid__column"
              :model="selectedFlight.applyDateRange"
              :inputData="getInput('applyDateRange')"
              :isEdit="isEdit"
              @updateModel="(event) => setValue('applyDateRange', event)"
              :validation="isValid('applyDateRange')"
            />
            <div class="flight-editor__grid">
              <Input
                class="flight-editor__grid__column"
                :model="selectedFlight.startDate"
                :inputData="getInput('startDate')"
                :isEdit="isEdit"
                @updateModel="(event) => setValue('startDate', event)"
                :validation="isValid('startDate')"
              />
              <Input
                class="flight-editor__grid__column"
                :model="selectedFlight.endDate"
                :inputData="getInput('endDate')"
                :isEdit="isEdit"
                @updateModel="(event) => setValue('endDate', event)"
                :validation="isValid('endDate')"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Products Begin  -->
      <EditorSection
        title="Products"
        sectionType="items"
        :bus="bus"
        :defaultIsOpen="true"
      >
        <Items :isEdit="isEdit" @discount-total="updateDiscountTotal" @sub-total="updateSubTotal" @grams="updateGrams" />
      </EditorSection>

      <EditorSection
        title="Menu and Kiosk Image"
        sectionType="onlineStore"
        :bus="bus"
        :defaultIsOpen="true"
      >
      <div class="two-columns-layout two-columns-layout--responsive">
        <Input
            :model="selectedFlight.imageNormal"
            :inputData="getInput('imageNormal')"
            :isEdit="isEdit"
            @updateModel="selectedFlight.imageNormal = $event"
          />
          <Input
            :model="selectedFlight.notes"
            :inputData="getInput('notes')"
            :isEdit="isEdit"
            @updateModel="selectedFlight.notes = $event"
          />
        </div>
      </EditorSection>
    </div>
    <SearchModal
      v-if="showSearchModal"
      :showSearchModal="showSearchModal"
      @toggle-modal="() => (showSearchModal = !showSearchModal)"
      :entity="entity"
      :forcedFilterCriteria="filterCriteria"
      :columnHeaders="columnHeaders"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";

import PageHeader from "@/components/PageHeader.vue";
import Input from "@/components/Input/Input.vue";
import Items from "./components/FlightItems/FlightItems.vue";
import ContainerLabel from "@/components/ContainerLabel/ContainerLabel.vue";
import EditorSection from "@/components/EditorSection";

import Constants from "@/resources/Constants";
import Utilities from "@/lib/Utilities";
import Entities from "@/resources/Entities";

import { validateFields } from "@/utils/validation/flight";

import {
  flightInfoInputs,
  defaultSelectedFlight,
  pageHeader,
  filterCriteria,
  columnHeaders,
} from "./inputs";

export default {
  name: "flightEditor",
  data() {
    return {
      Constants,
      moment,
      Utilities,
      flightInfoInputs,
      isEdit: false,
      defaultSelectedFlight,
      flights: [],
      flightsResults: [],
      bus: new Vue(),
      isCollapsed: true,
      entity: Entities.FLIGHT,
      pageHeader,
      showSearchModal: false,
      filterCriteria,
      columnHeaders,
      Entities,
      validationErrors: {},
    };
  },
  components: {
    PageHeader,
    Input,
    ContainerLabel,
    Items,
    EditorSection,
  },
  mounted: function () {
    this.setPageTitle("Bundles");
    const id = this.$route.query.id;
    if (id && id !== "NEW") {
      this.getFlightById({ _id: id });
    } else {
      this.isEdit = true;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEdit) {
      this.setMessagePopUp({
        isOpen: true,
        title: Constants.strings.unsavedChangesTitle,
        message: Constants.strings.unsavedChangesConfirmation,
        positiveCallback: (data) => {
          next(true);
        },
      });
    } else {
      next(true);
    }
  },
  watch: {
    id: function () {
      if (this.id && this.id !== "NEW") {
        this.getFlightById({
          _id: this.id,
        });
        document.getElementById("app-body").scrollTo(0, 0);
      }
    },
  },
  computed: {
    id: {
      get() {
        return this.$route.query.id;
      },
      set(id) {
        return id;
      },
    },
    ...mapGetters({
      flight: "flightModule/flight",
    }),
    selectedFlight: {
      get() {
        this.setPageTitle("Bundle " + this.flight?.name);
        return this.prefillEntityBeforeRendering(this.flight);
      },
      set(entity) {
        return entity;
      },
    },
  },
  methods: {
    ...mapActions({
      getFlightById: "flightModule/getFlightById",
      saveFlight: "flightModule/saveFlight",
      deleteFlight: "flightModule/deleteFlight",
      setMessagePopUp: "setMessagePopUp",
      setMessage: "setMessage",
      getFlights: "flightModule/getFlights",
    }),
    toggleSections: function () {
      this.isCollapsed = !this.isCollapsed;
    },
    updateDiscountTotal(discountTotal) {
      this.selectedFlight.discountTotal = discountTotal;
    },
    updateSubTotal(subTotal) {
      this.selectedFlight.subTotal = subTotal;
    },
    updateGrams(grams) {
      this.selectedFlight.grams = grams;
    },
    prefillEntityBeforeRendering(selectedFlight) {
      if (!selectedFlight.imageNormal) {
        selectedFlight.imageNormal = {}
      }

      if (!selectedFlight.imageThumbnail) {
        selectedFlight.imageThumbnail = {}
      }
      return selectedFlight
    },
    saveCalculateGrams() {
      // this.selectedFlight.grams = this.calculateGrams;
    },
    getInput(field) {
      return flightInfoInputs.find((i) => i.id == field);
    },
    forceToggle() {
      this.isCollapsed = !this.isCollapsed;
      this.bus.$emit("forceToggle", this.isCollapsed);
    },
    toggleEdit() {
      if (!(this.selectedFlight._id === "NEW")) this.isEdit = !this.isEdit;
      if (this.selectedFlight._id === "NEW") {
        this.isEdit = true;
      }
    },
    updateImageSecureUrl(imageUrl) {
      if (!this.selectedFlight.imageNormal) {
        this.selectedFlight.imageNormal = {}
      }
      this.selectedFlight.imageNormal.secure_url = imageUrl
    },
    getImageSecureUrl() {
      return this.selectedFlight?.imageNormal?.secure_url
    },
    handleAdjacent: async function (mode) {
      this.getAdjacent({
        createdAt: this.selectedFlight.createdAt,
        mode,
        positiveCallback: (adjacent) => {
          if (adjacent) this.selectedFlight = adjacent;
        },
      });
    },
    toggleSearchModal: function () {
      this.showSearchModal = !this.showSearchModal;
    },
    isValid(field) {
      return _.get(this.validationErrors, field);
    },
    setValue(field, value) {
      _.set(this.selectedFlight, field, value);
      validateFields(this.selectedFlight, field, this.validationErrors);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./_flightEditor.scss";
</style>
